<script lang="ts" setup>
import { reactive } from 'vue';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const welfareTab = reactive([
  {
    title: t('cooperation.welfareDonate.welfareTab.title1'),
  },
  {
    title: t('cooperation.welfareDonate.welfareTab.title2'),
  },
])

const specialTabpanel = {
  headerTitle: t('cooperation.welfareDonate.welfareTab.title2'),
  list: [
    t('cooperation.welfareDonate.specialTabpanel.list1'),
    t('cooperation.welfareDonate.specialTabpanel.list2'),
  ],
  contentTitle: t('cooperation.welfareDonate.welfareTab.contentTitle'),
  contentList: [
    {
      title: t('cooperation.welfareDonate.contentList.title1'),
      desc: t('cooperation.welfareDonate.contentList.desc1'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title2'),
      desc: t('cooperation.welfareDonate.contentList.desc2'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title3'),
      desc: t('cooperation.welfareDonate.contentList.desc3'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title4'),
      desc: t('cooperation.welfareDonate.contentList.desc4'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title5'),
      desc: t('cooperation.welfareDonate.contentList.desc5'),
    },
  ],
}

const unSpecialTabpanel = {
  headerTitle: t('cooperation.unSpecialPanel.title'),
  headerContent: t('cooperation.unSpecialPanel.content'),
  contentList: [
    {
      title: t('cooperation.unSpecialPanel.extraordinaryTitle'),
      desc: t('cooperation.unSpecialPanel.extraordinaryRule'),
    },
    {
      title: t('cooperation.unSpecialPanel.platinumTitle'),
      desc: t('cooperation.unSpecialPanel.platinumRule'),
    },
    {
      title: t('cooperation.unSpecialPanel.goldTitle'),
      desc: t('cooperation.unSpecialPanel.goldRule'),
    },
    {
      title: t('cooperation.unSpecialPanel.silverTitle'),
      desc: t('cooperation.unSpecialPanel.silverRule'),
    },
  ],
}
</script>

<template>
  <section class="page-cooperation-welfare">
    <h3>{{ $t('cooperation.welfareDonate.title') }}</h3>
    <TabGroup>
      <TabList class="tablist relative flex" v-slot="{ selectedIndex }">
        <div class="absolute underline" :class="`item-${selectedIndex}`"></div>
        <Tab
          v-for="item in welfareTab"
          :key="item.title"
          as="template"
          v-slot="{ selected }"
        >
          <div
            :class="[
              'tablist-btn',
              selected
                ? 'selected'
                : ''
            ]"
          >
            {{ item.title }}
          </div>
        </Tab>
      </TabList>

      <TabPanels class="tabpannels relative">
        <TabPanel as="template" v-slot="{ selected }" static>
          <Transition name="tab-panel">
            <div class="tabpanel tabpanel-card relative w-full flex items-center justify-center <md:overflow-hidden" v-show="selected">
              <img src="@/assets/cooperation/unspecial-bg.png" class="absolute left-0 top-0 h-full -z-1" alt="">
              <div class="tabpanel-card-content mx-auto flex items-start justify-between <md:flex-col <md:items-stretch <md:gap-24">
                <div class="content-detail text-white">
                  <h4 class="content-title mb-0 mt-0 truncate text-white" :title="unSpecialTabpanel.headerTitle">{{ unSpecialTabpanel.headerTitle }}</h4>
                  <span class="mt-32px block h-192px w-330px overflow-x-auto text-justify text-16px font-normal leading-24px <2xl:mt-16px <2xl:h-216px <2xl:w-250px <2xl:text-14px <md:h-auto <md:w-full">
                    {{ unSpecialTabpanel.headerContent }}
                  </span>
                </div>
                <div class="unspecial-container h-274px w-998px rounded-[4px] <2xl:w-918px <md:h-auto <md:w-full">
                  <ul class="unspecial-container-ul relative m-0 mt-32px h-186px flex flex-wrap list-none p-0 after:absolute after:left-1/2 after:h-186px after:w-2px after:content-empty after:-translate-x-1/2 before:absolute before:left-56px before:top-1/2 before:h-2px before:w-886px before:content-empty before:-translate-y-1/2 <md:h-auto <md:flex-col <md:gap-16 <md:after:hidden <md:before:hidden">
                    <li v-for="(item, index) in unSpecialTabpanel.contentList" :key="index" class="h-1/2 w-1/2 px-56px <md:h-auto <md:w-full <md:px-16" :class="{ 'pt-16px': index > 1 }">
                      <div class="truncate text-[24px] text-#1180FF font-medium leading-36px <md:text-18">{{ item.title }}</div>
                      <div class="mt-8px text-[16px] text-#2D2D2D font-medium leading-[24px] <2xl:w-387px <md:w-full">{{ item.desc }}</div>
                    </li>
                  </ul>
                  <div class="ml-56px mt-6px text-14px color-hex-9A9EA6 font-400 leading-22px <md:mb-16 <md:ml-16">
                    <span class="mr-16px">* {{ $t('cooperation.welfareDonate.telephone') }}</span>
                    <span>{{ $t('cooperation.welfareDonate.email') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </TabPanel>

        <TabPanel as="template" v-slot="{ selected }" static>
          <Transition name="tab-panel">
            <div class="tabpanel tabpanel-card relative w-full flex items-center justify-center <md:overflow-hidden" v-show="selected">
              <img src="@/assets/cooperation/special-donate.png" class="absolute left-0 top-0 h-full -z-1" alt="">
              <div class="tabpanel-card-content mx-auto flex items-start justify-between <md:flex-col <md:items-stretch <md:gap-24">
                <div class="w-330px text-white <2xl:w-250px <md:w-full">
                  <h4 class="content-title mb-[8px] mt-0 truncate text-white" :title=" specialTabpanel.headerTitle ">{{ specialTabpanel.headerTitle }}</h4>
                  <div class="mt-24px h-205px overflow-x-auto <md:h-auto">
                    <span v-for="(item, index) in specialTabpanel.list" :key="index" class="content-desc mt-24px block <2xl:mt-0">{{ item }}</span>
                  </div>
                </div>
                <div class="content-card h-full w-998px rounded-[4px] bg-white <2xl:w-918px <md:w-full">
                  <h5 class="mt-0">{{ specialTabpanel.contentTitle }}</h5>
                  <div class="mb-8px h-52px w-790px bg-[url(@/assets/cooperation/welfare-step1.png)] bg-contain bg-no-repeat <md:hidden <2xl:w-719px <2xl:bg-[url(@/assets/cooperation/welfare-step2.png)]"></div>
                  <ul class="m-0 flex list-none items-start justify-start p-0 <md:flex-wrap">
                    <li v-for="(item, index) in specialTabpanel.contentList" :key="index" class="content-card-list mr-32px flex shrink-0 flex-col justify-start <2xl:mr-24px <md:mb-16 <md:mr-0 <md:w-full" :class="[index == 1 ? 'w-200px <2xl:w-200px' : 'w-144px <2xl:w-132px']">
                      <span class="mb-4px inline-block w-full text-[16px] font-medium">{{ item.title }}</span>
                      <span class="inline-block w-full text-[14px] font-normal leading-[22px]">{{ item.desc }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Transition>
        </TabPanel>
      </TabPanels>
    </TabGroup>
  </section>
</template>

<style lang="scss" scoped>
.page-cooperation-welfare {
  width: 100%;
  padding: calc(48px + 32px) 0 48px;  // 此处 calc 会走 scss 编译，这样写比较直观：标准间距加上导航栏吃进去的一部分，后续标准间距也方便改成全局 css 变量
  background: rgba(45, 45, 45, 0.02);

  h3 {
    height: 48px;
    margin-top: 0;
    margin-bottom: 16px;
    color: #2d2d2d;
    font-weight: 500;
    font-size: 32px;
    line-height: 48px;
    text-align: center;
  }

  .tablist {
    @apply w-1360px justify-center my-0px mx-auto <2xl:w-1200px;

    .underline {
      bottom: 0;
      width: 50%;
      height: 1px;
      background: #1180ff;
      transition: left .3s linear;
    }

    &-btn {
      width: 50%;
      margin-top: 18px;
      margin-bottom: 18px;
      color: #2d2d2d;
      font-weight: 400;
      font-size: 24px;
      line-height: 1.3;
      text-align: center;
      cursor: pointer;

      &:focus-visible {
        outline: unset;
      }

      &.selected {
        color: #1180ff;
      }
    }
    @for $i from 0 through 2 {
      .item-#{$i} {
        left: $i * 50%;
      }
    }
  }

  .tabpannels {
    margin-top: 32px;

    .tabpanel {
      width: 100%;
    }

    .tabpanel-card {
      height: 370px;

      &-bg {
        width: 1200px;
      }

      &-content {
        @apply w-1360px h-274px <2xl:w-1200px;

        .content-title {
          height: 48px;
          font-weight: 500;
          font-size: 32px;
          line-height: 48px;
        }

        .content-desc {
          font-size: 16px;
          line-height: 24px;
        }

        .content-card {
          padding: 32px 48px;
          box-shadow: 0 0 60px 0 rgba(0, 37, 79, 0.1);

          h5 {
            height: 36px;
            margin-bottom: 20px;
            font-size: 24px;
            line-height: 36px;
          }

          img {
            width: 790px;
            height: 52px;
            margin-bottom: 8px;
          }

          &-list:not(:last-child) {
            color: #2d2d2d;
          }
        }
      }
    }
  }

  .unspecial-container {
    background-color: rgba(255, 255, 255, 0.85);
    box-shadow: 0 0 60px 0 rgba(17, 128, 255, 0.1);

    .unspecial-container-ul:before {
      background: linear-gradient(243deg, rgba(45, 45, 45, 0) 0%, rgba(45, 45, 45, 0.06) 53%, rgba(45, 45, 45, 0) 100%);
    }

    .unspecial-container-ul:after {
      background: linear-gradient(243deg, rgba(45, 45, 45, 0) 0%, rgba(45, 45, 45, 0.08) 53%, rgba(45, 45, 45, 0) 100%);
    }
  }

  .tab-panel-enter-active,
  .tab-panel-leave-active {
    transition: opacity .9s;
    will-change: opacity;
  }

  .tab-panel-leave-active {
    position: absolute;
    top: 0;
    left: 0;
  }

  .tab-panel-enter-from,
  .tab-panel-leave-to {
    opacity: 0;
  }

  // 响应式：断点值与 uno.config 一致（xl=1280px / md=768px）
  @media (max-width: 1279.9px) {
    .tablist {
      width: 100%;
      padding-right: 24px;
      padding-left: 24px;
    }

    .tabpannels .tabpanel-card-content {
      width: 100%;
      padding-right: 24px;
      padding-left: 24px;
    }
  }

  @media (max-width: 767.9px) {
    h3 {
      font-size: 24px;
    }

    .tablist {
      padding-right: 16px;
      padding-left: 16px;
    }

    .tabpannels {
      .tabpanel-card {
        height: auto;
        padding-top: 24px;
        padding-bottom: 32px;

        &-content {
          height: auto;
          padding-right: 16px;
          padding-left: 16px;
        }
      }

      .content-title {
        height: auto;
        font-size: 24px;
        line-height: 36px;
      }

      .content-card h5 {
        font-size: 20px;
      }
    }
  }
}
</style>
